import { useTranslation } from 'react-i18next'

import { Button } from '../../global/button/Button'
import { NameDto } from '../../model/NameDto'
import { DropdownList } from '../../ui/v2/Dropdown/DropdownList'
import { DropdownListItem } from '../../ui/v2/Dropdown/DropdownListItem'
import { ExpandableBasicModalMobile } from '../../ui/v2/Modal/ExpandableModal/ExpandableBasicModalMobile'
import { cloneButtonLarge, getSortedButtons } from '../../ui/v2/Modal/common/helpers/button'

interface RebateOptionsModalProps<T = number> {
  options: NameDto<T>[]
  activeId?: T
  isLoading?: boolean
  onSelect: (option: NameDto<T>) => void
  onClose: () => void
}

export function RebateOptionsModal<T = number>({
  options,
  activeId,
  isLoading,
  onSelect,
  onClose,
}: RebateOptionsModalProps<T>): JSX.Element {
  const { t } = useTranslation()

  return (
    <ExpandableBasicModalMobile
      isLoading={isLoading}
      onClose={onClose}
      renderFooter={() =>
        getSortedButtons({}, [
          cloneButtonLarge(
            <Button.New appearance='secondary' onClick={onClose}>
              {t('Close')}
            </Button.New>
          ),
        ])
      }
    >
      <DropdownList isScrollable>
        {options?.map((option) => {
          return (
            <DropdownListItem
              key={option.id as string | number}
              onClick={() => onSelect(option)}
              isActive={option.id === activeId}
              hasCheckMark
            >
              {option.name}
            </DropdownListItem>
          )
        })}
      </DropdownList>
    </ExpandableBasicModalMobile>
  )
}
